/**
 * Cookie Confirm CMP
 * https://cookieconfirm.com/
 *
 * Cookie name: CC_p_accepted_cookies
 * Cookie values: ["functional","analytics","marketing"]
 *
 * Events:
 * - Cc_accept_all: User clicks "Accept All"
 * - Cc_decline_all: User clicks "Reject All" or closes banner
 * - Cc_accept_selection: User accepts custom selection
 * - Cc_ConsentSet: Any consent action (fires after all above events)
 */
export const cookieConfirm = {

	/**
	 * Get the Cookie Confirm consent from cookie.
	 *
	 * @returns {{statistics: boolean, marketing: boolean, preferences: boolean, necessary: boolean}|null}
	 */
	getConsent: () => {

		// Cookie value example: ["functional","analytics","marketing"]
		let consent = pmw.getCookie("CC_p_accepted_cookies")

		if (consent) {

			pmw.console.log("Cookie Confirm CMP consent detected")

			try {
				consent = JSON.parse(consent)
			} catch (e) {
				pmw.console.log("Cookie Confirm CMP: Error parsing cookie value", e)
				return null
			}

			// Ensure consent is an array
			if (!Array.isArray(consent)) {
				return null
			}

			return {
				statistics : consent.includes("analytics"),
				marketing  : consent.includes("marketing"),
				preferences: consent.includes("functional"),
				necessary  : true, // Necessary/functional is always true when consent is given
			}
		}

		return null
	},

	/**
	 * Load event listeners for Cookie Confirm CMP
	 *
	 * The Cc_ConsentSet event fires for every consent action (accept all, decline all, or custom selection)
	 * Event detail: { analytics: boolean, marketing: boolean, functional: true }
	 */
	loadEventListeners: () => {

		// Listen to the global consent event that fires for all consent actions
		document.addEventListener("Cc_ConsentSet", (e) => {

			const consent = e.detail

			let data = {
				statistics : consent.analytics ?? false,
				marketing  : consent.marketing ?? false,
				preferences: consent.functional ?? true,
				necessary  : true,
			}

			pmw.consent.api.updateSelectively({...data, source: "cmp"})
		}, true)
	},
}
